import React, { useEffect } from "react";
import SEO from "../../components/SEO";
import asset from "../../utils/assetUrl";

const SITE = 'https://conferenciaparacanada.com';

// Destino de la reserva de asesorías con Brenno Martins. La conversión la mide
// el PageView de Meta y de GA que ya dispara public/index.html al cargar la URL.
function GraciasCitas() {
    useEffect(() => {
        document.body.classList.add('thanks');
        return () => {
            document.body.classList.remove('thanks');
        };
    }, []);

    return (
        <>
            <SEO
                title="¡Tu reserva ha sido exitosa!"
                description="Estamos emocionados de acompañarte en tu camino hacia Canadá"
                keywords="conferencia para canada, estudiar en canada, migrar a canada, residencia permanente"
                ogImage={`${SITE}/assets/images/og.jpg`}
                favicon={`${SITE}/assets/images/favicon-32x32.png`}
                appleFavicon={`${SITE}/assets/images/apple-touch-icon.png`}
                canonical={`${SITE}/gracias-citas`}
                noindex
            />

            <div style={{ backgroundImage: `url(${asset('/assets/images/hero.jpg')})` }} className="hero hero--citas nostatic">
                <div className="container">
                    <img className="mainLogo" src={asset("/assets/images/Para_Canada_Conferencia_Logo_White.svg")} alt="Conferencia para Canadá" />
                    <hr />
                    <h1>¡Tu reserva con Brenno Martins ha sido exitosa, nos vemos pronto!</h1>

                    <p className="lead">
                        Has logrado conseguir un cupo con Brenno Martins. Te hemos enviado un correo
                        con la confirmación, que incluye el lugar exacto de la asesoría, la fecha y la hora.
                        <br />
                        <strong>¡Estamos emocionados de acompañarte en tu camino hacia Canadá!</strong>
                    </p>
                </div>
            </div>

            <footer className="footer nostatic" style={{ backgroundImage: `url(${asset('/assets/images/footer.jpg')})` }}>
                <div className="container">
                    <div className="row footer-contact">
                        <div className="col-12">
                            <h2 className="gradient-title">¿Dudas?</h2>
                            <p>
                                Si tienes alguna pregunta, no dudes en contactarnos a{" "}
                                <a style={{ display: 'block' }} target="_blank" rel="noreferrer" href="mailto:info@para-canada.com">
                                    info@para-canada.com
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="row footer-copy">
                        <div className="col-12">
                            <p>&copy; 2026. Todos los derechos reservados.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default GraciasCitas;
